/**
 * Public API for tracking page views and action clicks
 */
goog.provide('yext.analytics');
goog.provide('yext.pixel');

(function(window, document) {
  var PROTOCOL_BASE = 'http:' == window.location.protocol ? 'http://' : 'https://';
  var PIXEL_URL_BASE = 'yextevents.com/';
  var STORE_PAGES_ENDPOINT = 'store_pagespixel';
  var YTAG_SCRIPT_SRC = 'https://assets.sitescdn.net/ytag/ytag.min.js';
  var YTAG = 'yextConversionTag';
  var COOKIE_PARAM = '_yfpc';

  /**
   * Opts the client into pixel analytics. Note that opting out prevents opting into cookies as
   * well.
   *
   * @param {boolean} val - a boolean indicating whether the client wants to opt in to pixel
   *                        analytics.
   */
  var pixelOptIn = function(val) {
    if (val === true || val === false) {
      pixelOptedIn = val;
      if (pixelOptedIn && cookieOptedIn) {
        // Load ytag so a listings pixel can be fired if appropriate
        loadYtag();
      }
    }
  };
  yext.pixel.optIn = pixelOptIn;
  goog.exportSymbol('yext.pixel.optIn', pixelOptIn);

  /**
   * Indicates whether the client is opted into conversion pixel tracking. Note that opting in
   * opens the client up to having cookies being set in their browser.
   */
  var pixelOptedIn = true;

  /**
   * Opts the client into conversion pixel tracking. Note that opting in opens the client up
   * to having cookies being set in their browser. If the user chooses to opt-in, also triggers a
   * listings click event if the relevant conditions are in place.
   *
   * @param {boolean} val - a boolean indicating whether the client wants to opt in to pixel
   *                        tracking.
   */
  var cookieOptIn = function(val) {
    if (val === true || val === false) {
      cookieOptedIn = val;
      if (pixelOptedIn && cookieOptedIn) {
        // Load ytag so a listings pixel can be fired if appropriate
        loadYtag();
      }
    }
  };
  goog.exportSymbol('yext.analytics.optIn', cookieOptIn); // Deprecated
  goog.exportSymbol('yext.cookies.optIn', cookieOptIn);
  goog.exportSymbol('yext.cookie.optIn', cookieOptIn);

  /**
   * Indicates whether the client is opted into conversion pixel tracking. Note that opting in
   * opens the client up to having cookies being set in their browser.
   */
  var cookieOptedIn = false;

  var checkWindowOptIn = function() {
    var pixelQ = window['yPixelOptInQ'] || [];
    for (var arg of pixelQ) {
      if (typeof arg === 'boolean') {
        pixelOptIn(arg);
      } else if (typeof arg === 'object') {
        pixelOptIn(arg[0]);
      }
    }

    var cookieQ = window['yCookieOptInQ'] || window['yOptInQ'] || [];
    for (var args of cookieQ) {
      cookieOptIn(args[0]);
    }
  };
  yext.pixel.checkWindowOptIn = checkWindowOptIn;
  goog.exportSymbol('yext.pixel.checkWindowOptIn', checkWindowOptIn);
  // Library is loaded asynchronously so check for any optin calls before the lib was loaded
  checkWindowOptIn();

  /**
   * Returns a set of tracking functions that the client can call
   *
   * If you change these fields data may be silently dropped.
   * Please test all changes thoroughly and make sure these are consistent with
   * src/com/yext/ups/tracking/v2/TrackingLogger.java
   *
   * @param {!Object} data An object containing key-value pairs to store in record
   * @return {!function(string, function())} - Record building function that takes an event_type and
   *                                           callback
   */
  var getYextAnalytics = function(data) {
    var record = function(event_type, callback) {
      if (pixelOptedIn) {
        data['pagesReferrer'] = document.referrer;
        data['pageurl'] = document.location.pathname;
        data['eventType'] = event_type;
        data['pageDomain'] = document.location.hostname;

        var queryParams = getQueryParams_();
        if (queryParams) {
          data['queryParams'] = encodeURIComponent(JSON.stringify(queryParams));
        }

        // Build tracker target url, then add pixel
        getTrackerUrl(STORE_PAGES_ENDPOINT, data, function(trackerUrl) {
          addPixel(trackerUrl, callback);
        });
      }
    };

    return record;
  };
  yext.analytics.getYextAnalytics = getYextAnalytics;
  goog.exportSymbol('yext.analytics.getYextAnalytics', getYextAnalytics);

  /**
   * Calls callback() on the tracker url, formed using the protocol base,
   * partition prefix, pixel url, endpoint, and the query params in data.
   *
   * @param {string} endpoint The endpoint this URL is associated with
   * @param {!Object} data An object containing key-value pairs to include in the URL as params
   * @param {!function(string)} callback A function to be called on the returned trackerUrl
   */
  var getTrackerUrl = function(endpoint, data, callback) {
    const partitionPrefix = data['partition']
          ? data['partition']
          : determinePartition(data['businessids']);
    const envPrefix = data['env'] && data['env'] !== 'prod'
          ? `${data['env']}.`
          : '';
    const url = PROTOCOL_BASE + envPrefix + partitionPrefix + '.' + PIXEL_URL_BASE + endpoint;
    if (cookieOptedIn) {
      callWithYtag(function() {
        var cookieValue = window[YTAG]('yfpc')[COOKIE_PARAM];
        data[COOKIE_PARAM] = cookieValue;
        callback(url + getUrlParameters(data));
      });
    } else {
      callback(url + getUrlParameters(data));
    }
  };

  /**
   * Gets partition prefix which is encoded in the businessId. Logic deduced from:
   * https://gerrit.yext.com/c/alpha/+/179008

   * @param {number} businessId
   */
  var determinePartition = function(businessId) {
    if (businessId === undefined || businessId === null) {
      throw new Error('Business ID was null or undefined');
    }
    switch (Math.floor(businessId / 100000000 % 10)) {
      case 0:
        return YextPartition.US;
      case 1:
        return YextPartition.EU;
      default:
        throw new Error('Invalid Business ID');
    }
  };

  const YextPartition = {
    US: 'us',
    EU: 'eu',
  };

  yext.analytics.YextPartition = YextPartition;
  goog.exportSymbol('yext.analytics.YextPartition', YextPartition);

  /**
   * Loads ytag.js, the other conversion tracking library, which contains code for setting and
   * getting cookies, unless already loaded. Call callback() once loaded (or if already loaded,
   * just call callback() immediately).
   *
   * @param {!function()} callback A function to call when ytag finishes loading
   */
  var callWithYtag = function(callback) {
    var script = loadYtag();

    // Script is present, but not necessarily loaded yet
    if (window[YTAG]) {
      callback();
    } else {
      // Note: In theory, there may be a race condition where window[YTAG] could've been undefined,
      // leading to this else block, but the library completes loading prior to execution of
      // existingScript.addEventListener, leading to the call to callback() being dropped.
      script.addEventListener('load', callback);
    }
  };

  /**
   * Loads ytag.js, the other conversion tracking library, if it has not already been loaded.
   * Returns the HTMLScriptElement whose src references ytag.js.
   *
   * @returns {Element} The script element that references ytag.js
   */
  var loadYtag = function() {
    var existingScript = document.querySelector('script[src="' + YTAG_SCRIPT_SRC + '"]');

    if (!existingScript) {
      var script = document.createElement('script');
      script.src = YTAG_SCRIPT_SRC;
      document.body.appendChild(script);
      return script;
    }
    return existingScript;
  };

  /**
   * Given an object, returns the equivalent url param string.
   *
   * Does not URL encode param values, since it wasn't done when the library was originally
   * implemented and current implementations now depend on non-encoded values. Encoding could
   * break legacy integrations.
   *
   * @param {!Object} data - object containing all the key-values to append to
   *                        the url. Values are expected to already be URL encoded.
   * @return {string} Appended url params
   */
  var getUrlParameters = function(data) {
    var params = '';
    var i = 0;

    data['v'] = generateCacheBuster();
    for (var property in data) {
      params = params + ((i === 0) ? '?' : '&');
      params = params +
        property +
        '=' +
        // This method does not URL encode param values.
        data[property];
      i = i + 1;
    }
    return params;
  };

  /**
   * Generate a random number for cache buster query param.
   * @return {number} The cache buster value
   */
  var generateCacheBuster = function() {
    return Date.now() + Math.floor(Math.random() * 1000);
  };

  /**
   * Appends a 1px x 1px pixel (img tag) to the page with the given src target
   * @param {string} src - target url for the pixel
   * @param {!function(Object)} callback A function to call when pixel is added
   */
  var addPixel = function(src, callback) {
    var img = document.createElement('img');
    var eventHandler = function(evt) {
      callback(evt);
    };

    if (callback) {
      img.onload = eventHandler;
      img.onerror = img.onabort = eventHandler;
    }

    img.src = src;
    img.width = '0';
    img.height = '0';
    img.style.setProperty('width', '0', 'important');
    img.style.setProperty('height', '0', 'important');
    img.style.position = 'absolute';
    img.alt = '';
    if (document.body) {
      document.body.appendChild(img);
    }
  };

  /**
   * Get the URL query parameters from window.location.search
   *
   * @return {Object} The decoded URL parameters
   */
  function getQueryParams_() {
    var params = {};
    var vars = window.location.search.substring(1).split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      var key = decodeURIComponent(pair[0]);
      var val = decodeURIComponent(pair[1]);
      if (key in params) {
        var existingVal = params[key];
        params[key] = Array.isArray(existingVal) ? existingVal.concat(val) : [existingVal, val];
      } else {
        params[key] = val;
      }
    }
    return params;
  }
}(window, document));
